module.exports =
`
# 隐私权政策

「MUZIK Air」是由「希幔科技有限公司（MUZIK CREATIVE DIGITAL LTD. ）」所经营及提供的以古典音乐结合科技与网路社群功能的线上收听平台。我们非常尊重会员的个人隐私，以下是我们的隐私权保护政策，以帮助会员了解 MUZIK Air 相关网站如何搜集运用并保护会员个人资料。

- 取得会员个人资料

  一丶当会员注册成为 MUZIK-Air 会员时，本网站会要求会员输入使用者名称丶电子邮件地址丶个人头像丶昵称丶性别丶出生年丶出生月丶学历丶行业类别丶年收入。

  二丶使用意见与问题回报时，本网站会要求会员提供电子信箱，以利我们为会员提供正确且快速的客户服务。会员个人资料的使用

  三丶本网站所搜集的个人资料，仅供做身分判定的依据，非经会员同意，本网站不会将这些资讯用做其他用途或与第三者分享，第三者也无权使用这些资讯。

  四丶当会员可能违反本网站服务条款或是损害本网站及本网站其他会员，或司法单位因公众安全要求我们公开特定会员的个人资料时，本网站将在合法的程序下揭露或读取会员资料的动作。

- 会员个人资料的使用

  一丶本网站所搜集的个人资料，仅供做身分判定的依据，非经会员同意，本网站不会将这些资讯用做其他用途或与第三者分享，第三者也无权使用这些资讯。

  二丶当会员可能违反本网站服务条款或是损害本网站及本网站其他会员，或司法单位因公众安全要求我们公开特定会员的个人资料时，本网站将在合法的程序下揭露或读取会员资料的动作。

- 会员个人资料的自主权

  一丶MUZIK Air 提供会员填写个人资料的自主权。当会员主动同意我们的服务条款并注册成会员，会员有权决定是否提供其他个人资料给本网站使用。

  二丶MUZIK Air 并提供会员主动查阅丶修改丶删除会员个人登录资料的权利，包括接受相关活动或电子报通知与否的决定权。

- 会员个人资料的安全

  一丶为尊重会员的隐私，在部分情况下我们使用So-Net线上金流服务的SSL安全机制保障用户个人资料传送的安全。请会员妥善保管会员的密码与个人资料，并提醒会员使用完毕 MUZIK Air 的相关服务後，务必登出或关闭浏览器视窗，以免会员的资料遭人盗用。

  二丶MUZIK Air 相关网站均有可能包含其他网站或网页连结，也有可能会搜集会员的个人资料，不论其内容或隐私权政策为何，皆与 MUZIK Air 无关，本网站不负任何连带责任。

- 其他资料的搜集和使用

  一丶本网站／系统会记录会员上站的位址，以及在相关站内浏览活动等资料，这些资料仅供做下列用途：分析会员喜好与习惯丶计算并统计浏览人次及流量丶根据会员的行为与偏好做适当的网页内容调整。我们并不会将此些资料对应会员之个人资料。

  二丶本网站保留对於搜集及分析使用者习惯相关资料的一切权利。

- 隐私权政策之修改

  MUZIK Air 拥有修改本隐私权政策的权利，当我们做出重大修改时，会於官方网站张贴告示或以电子报方式通知相关事宜。

`
